// src/pages/Admin/UserRegister.js
import React, { useState } from 'react';
import axios from 'axios';
import API_BASE_URL from '../../Config';


const UserRegister = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await axios.post(`${API_BASE_URL}/api/usuarios/registrar`, {
        username,
        password
      });

      alert('✅ Usuario registrado correctamente');
      setUsername('');
      setPassword('');
    } catch (error) {
      console.error('❌ Error al registrar usuario:', error);
      alert('Error al registrar usuario');
    }
  };

  return (
    <div className="flex justify-center items-center h-screen bg-gray-100">
      <form onSubmit={handleSubmit} className="bg-white p-6 rounded shadow-md w-80">
        <h2 className="text-lg font-semibold mb-4 text-center">Registro de Usuario</h2>
        <input
          type="text"
          placeholder="Nombre de usuario"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          className="mb-3 w-full border px-3 py-2 rounded"
        />
        <input
          type="password"
          placeholder="Contraseña"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="mb-4 w-full border px-3 py-2 rounded"
        />
        <button type="submit" className="w-full bg-green-600 text-white py-2 rounded hover:bg-green-700">
          Crear Usuario
        </button>
      </form>
    </div>
  );
};

export default UserRegister;
